import React from 'react';
import { useSelector } from 'react-redux';
import LayerStyles from '../LayerStyles';
import VectorLayer from './VectorLayer';

export default function ActiveFeaturesLayer() {
  const activeFeatures = useSelector(state => state.map.activeFeatures);

  return <VectorLayer features={activeFeatures} style={LayerStyles.activeFeature} zIndex={1000} />;
}